import { render, staticRenderFns } from "./TagsInfo.vue?vue&type=template&id=2452b2aa&scoped=true&"
import script from "./TagsInfo.vue?vue&type=script&lang=js&"
export * from "./TagsInfo.vue?vue&type=script&lang=js&"
import style0 from "./TagsInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TagsInfo.vue?vue&type=style&index=1&id=2452b2aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452b2aa",
  null
  
)

export default component.exports